import { NctsPhase, NctsScope } from '../../../../shared/ncts/types'
import { ServerValidationResult } from '../../models/types'
import { fromValidationResponse, toValidateRequest } from '../models/mapper'
import { validateTransitOperationV3 } from './http'

// eslint-disable-next-line import/prefer-default-export
export async function validateTransitOperation(id: number, params: {
  phase: NctsPhase
  houseConsignmentId?: number
  consignmentItemId?: number
  scope?: NctsScope
  isOptIn?: boolean
}): Promise<ServerValidationResult> {
  const { scope } = params
  const response = await validateTransitOperationV3(id, toValidateRequest(params), scope)

  return fromValidationResponse(response, scope)
}
